import styled from '@emotion/styled';

export const GroupDivider = styled('div')((p) => ({
  backgroundColor: p.theme.custom.colors.gray.w100,
  color: p.theme.custom.colors.gray.w700,
  fontSize: p.theme.custom.fontSize.s,
  fontWeight: 'normal',
  padding: p.theme.spacing(1)
}));
